import { NextRouter } from 'next/router'

export const makePageUrl = (page: number, route: NextRouter) => {
  const [path, queryParams] = route.asPath.split('?')

  const searchParams = new URLSearchParams(queryParams)
  searchParams.delete('pagina')

  if (page > 1) {
    searchParams.set('pagina', page.toString())
  }

  // toString() em vez de `searchParams.size`, que não existe no Node 18 nem no Safari
  // anterior ao 17: lá todo link de página saía sem o ?pagina. TNDC-438.
  const query = searchParams.toString()
  if (query) {
    const decodeURI = decodeURIComponent(`${path}?${query}`)
    return decodeURI
  }

  return path
}
